
import React from 'react';
import { BUSINESS_INFO } from '../constants';
import { RefreshCw, CheckCircle, Mail, Phone } from 'lucide-react';

const RefundPolicy: React.FC = () => {
  return (
    <div className="bg-transparent min-h-screen py-20 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="bg-white p-8 md:p-16 rounded-[3rem] shadow-2xl border border-slate-50 reveal-up">
          <div className="flex items-center space-x-4 mb-12">
            <div className="bg-teal-600 p-4 rounded-2xl shadow-xl shadow-teal-600/20">
              <RefreshCw className="h-8 w-8 text-white" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900">Refund & Cancellation</h1>
          </div>
          
          <div className="space-y-12 text-slate-600 leading-relaxed text-lg">
            <section>
              <p className="text-xl font-medium text-slate-800 mb-6">
                At {BUSINESS_INFO.name}, we prioritize customer satisfaction and handle every request with fairness and integrity.
              </p>
              <p>
                Refunds or cancellations are evaluated on a case-by-case basis. We understand that wellness journeys are personal, and we aim to address concerns with transparency.
              </p>
            </section>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-slate-50 p-8 rounded-[2rem] border border-slate-100">
                <h3 className="font-bold text-slate-900 mb-4 flex items-center">
                  <CheckCircle className="w-5 h-5 mr-2 text-teal-600" /> Our Process
                </h3>
                <ul className="space-y-3 text-sm">
                  <li>Inquiry submission via email/phone.</li>
                  <li>Internal review of order details.</li>
                  <li>Communication of decision within 48 hours.</li>
                  <li>Processing of applicable refunds within 7 days.</li>
                </ul>
              </div>
              <div className="bg-teal-50/50 p-8 rounded-[2rem] border border-teal-100">
                <h3 className="font-bold text-slate-900 mb-4 flex items-center">
                  <Mail className="w-5 h-5 mr-2 text-teal-600" /> Support Channels
                </h3>
                <p className="text-sm mb-4">Please reach out with your order ID and the reason for your request:</p>
                <div className="space-y-2 text-sm font-bold text-slate-800">
                  <div className="flex items-center space-x-2">
                    <Mail className="w-4 h-4 text-teal-600" />
                    <span>{BUSINESS_INFO.email}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Phone className="w-4 h-4 text-teal-600" />
                    <span>{BUSINESS_INFO.phone}</span>
                  </div>
                </div>
              </div>
            </div>

            <section className="pt-8 text-sm italic border-t border-slate-100">
              <p>
                Note: Standard processing times for bank transfers may vary. We are not liable for delays caused by financial institutions.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
